module.exports = __webpack_public_path__ + "img/set_tab_arrow.b00c8ec5.svg";